// extracted by mini-css-extract-plugin
export default {"contain":"contain_contain__YHLIV","contain_color":"contain_contain_color__TmmKJ","nopadding":"contain_nopadding__nOe6Y"};